import { render, staticRenderFns } from "./TenantAccounts.vue?vue&type=template&id=3bbfdbfe&scoped=true&"
import script from "./TenantAccounts.vue?vue&type=script&lang=js&"
export * from "./TenantAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TenantAccounts.vue?vue&type=style&index=0&id=3bbfdbfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfdbfe",
  null
  
)

export default component.exports